import React from "react";
import { useField } from "formik";
import PhoneInput from "react-phone-number-input";
import { ErrorM } from "components/helpers";
import "react-phone-number-input/style.css";

export const FormPhoneNumberField = (props: {
  field: string;
  label?: string;
  sideBySide?: boolean;
  required?: boolean;
}) => {
  const [field, meta, helpers] = useField(props.field);
  const showError = meta.touched && meta.error;

  return (
    <div
      className={`FormBox PhoneNumberBox ${props.sideBySide && "SideBySide"}`}
    >
      <div className="FormLabel">
        <label>{props.label}</label>
      </div>
      <div onBlur={() => helpers.setTouched(true)}>
        <PhoneInput
          className="EditBox"
          value={field.value}
          onChange={(value: any) => {
            value && helpers.setValue(value);
          }}
          defaultCountry={"US"}
          name={props.field}
          numberInputProps={{
            className: `EditBox${showError ? " ErrorInput" : ""}`,
          }}
          required={props.required}
        />
        <ErrorM name={props.field} />
      </div>
    </div>
  );
};
